module.exports = __webpack_public_path__ + "static/img/M-4.7fd37be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/myixuekao/M-4.png
// module id = BCK1
// module chunks = 0